import { render, staticRenderFns } from "./whatsAppMessage.vue?vue&type=template&id=d37661c4&scoped=true&"
import script from "./whatsAppMessage.vue?vue&type=script&lang=ts&"
export * from "./whatsAppMessage.vue?vue&type=script&lang=ts&"
import style0 from "./whatsAppMessage.vue?vue&type=style&index=0&id=d37661c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37661c4",
  null
  
)

export default component.exports